import { toast } from '@/components/ui/sonner';

const DONATE_URL = 'https://buymeacoffee.com/mauriziopinkrosa';

export const DonationBanner = () => (
  <aside
    data-testid="donation-banner"
    className="fixed inset-x-0 bottom-0 z-[60] bg-[#0A0A0A]/95 backdrop-blur-xl border-t border-pink-400/20 shadow-[0_-8px_30px_rgba(0,0,0,0.6)]"
    style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
  >
    <div className="max-w-6xl mx-auto h-[var(--donation-h)] px-3 sm:px-8 flex items-center justify-between gap-3">
      <p data-testid="donation-banner-text" className="min-w-0 text-[10px] min-[360px]:text-[11px] sm:text-sm leading-snug text-white/70 line-clamp-3 min-[360px]:line-clamp-2">
        🎵 Aiutami a mantenere questa suite gratuita e senza pubblicità
      </p>
      <a
        data-testid="donation-banner-btn"
        href={DONATE_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => toast('Grazie di cuore per il tuo supporto! 💖', { duration: 4000 })}
        className="shrink-0 h-9 sm:h-10 px-2.5 min-[360px]:px-3 sm:px-5 rounded-full bg-pink-400 text-black text-[11px] sm:text-xs font-semibold uppercase tracking-[0.12em] whitespace-nowrap inline-flex items-center shadow-[0_0_18px_rgba(236,72,153,0.45)] transition-[transform,background-color,box-shadow] duration-200 hover:bg-pink-300 hover:shadow-[0_0_26px_rgba(236,72,153,0.7)] active:scale-95"
      >
        ☕ Offrimi un caffè
      </a>
    </div>
  </aside>
);
